module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Weight#1-fbdeae1dc7e52ae9f9f94fd51a6b8473.svg";